import Meta from '../common/Meta'
import Header from '../common/components/header/Header'
import classes from './Learning.module.css'
import { useState } from 'react'
import Tabs from '../stories/Tabs/Tabs'
import MyLearning from './MyLearning'
import { useMediaQuery } from '@mantine/hooks'
import clsx from 'clsx'
import XPRank from './XPRank'

export default function Learning() {
  const tabs = [
    {
      value: 'my-learning',
      label: 'My Learning',
    },
    {
      value: 'xp-rank',
      label: 'XP Rank',
    },
  ]
  const [activeTab, setActiveTab] = useState<string>('my-learning')
  const isDesktop = useMediaQuery('(min-width: 800px)')

  return (
    <div className={classes.container}>
      <Meta title="Learning XP" />
      <Header title="Learning XP" />
      <div
        className={clsx(classes.learningWrapper, {
          [classes.learningWrapperMobile]: !isDesktop,
        })}
      >
        <Tabs items={tabs} value={activeTab} onChange={setActiveTab} isLarge />

        {activeTab === 'my-learning' && <MyLearning />}
        {activeTab === 'xp-rank' && <XPRank />}
      </div>
    </div>
  )
}
